document.addEventListener('DOMContentLoaded', () => {
  const openModalButtons = document.querySelectorAll('[data-open-modal]');
  const closeModalButtons = document.querySelectorAll('[data-close-modal]');
  const jobModals = document.querySelectorAll('.job-modal');

  // Function to open a specific modal
  const openModal = (jobId) => {
    const modal = document.getElementById(`job-modal-${jobId}`);
    if (modal) {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Prevent scrolling on body
    }
  };

  // Function to close a specific modal
  const closeModal = (jobId) => {
    const modal = document.getElementById(`job-modal-${jobId}`);
    if (modal) {
      modal.classList.remove('is-open');
      document.body.style.overflow = ''; // Restore body scrolling
    }
  };

  // Event listeners for opening modals
  openModalButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      const jobId = event.currentTarget.dataset.openModal;
      openModal(jobId);
    });
  });

  // Event listeners for closing modals
  closeModalButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      const jobId = event.currentTarget.dataset.closeModal;
      closeModal(jobId);
    });
  });

  // Close modal when clicking outside of the modal content
  jobModals.forEach(modal => {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) { // Check if the click was directly on the modal backdrop
        const jobId = event.target.id.replace('job-modal-', '');
        closeModal(jobId);
      }
    });
  });

  // Close modal when pressing the Escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      jobModals.forEach(modal => {
        if (modal.classList.contains('is-open')) {
          const jobId = modal.id.replace('job-modal-', '');
          closeModal(jobId);
        }
      });
    }
  });
});